export const bookmarkFilled = {
  name: "bookmark-filled" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.6 2.5a.9.9 0 0 1 .9-.9h15a.9.9 0 0 1 .9.9v19a.9.9 0 0 1-1.432.726L12 17.116l-6.968 5.11A.9.9 0 0 1 3.6 21.5v-19Z" clip-rule="evenodd"/></svg>`,
  keywords: ["bookmark-filled"],
  category: "action" as const,
};
